export const maxProceduresForCategoryChange: number = 15;
